import React, { useState, useEffect } from 'react';
import { DatePicker, Input, Image as AntdImage, Tooltip, Tag } from 'antd';
import { CaretDownOutlined, SearchOutlined } from '@ant-design/icons';
import moment from 'moment';

import Iconfont from "../../../../components/Iconfont/Iconfont";
import dateIcon from "../../../../assets/img/V7/dateIcon.svg";
import Api from "../../../../api";
import "./index.scss";

const { RangePicker } = DatePicker;
const Local = ({
    ministryHtml,
    key,
    callBack,
    searchData,
    policyTypeId,
    countryDeptList,
    regionList
}) => {
     // 政策
    const [tooltipIsOpen, setTooltipIsOpen] = useState(false); // 控制选择地区/部委弹窗是否显示
    const [selectedMinistriesList, setSelectedMinistriesList] = useState([]); // 选择的部委
    const [selectedMinistries, setSelectedMinistries] = useState([]); // 选择的部委对象

    const [regions, setRegions] = useState({
        saidiCity: [],
        geographic: [],
    });
    const [allRegions, setAllRegions] = useState([]);
    const [sortType, setSortType] = useState("geographic");// 赛迪分区(saidiCity) / 地理分区(geographic)
    const [selectedAreaList, setSelectedAreaList] = useState([]); // 选择的地方codes
    const [selectedRegions, setSelectedRegions] = useState([]); // 选择的地方对象

    const sortTypeList = [
        {text: "按地理分区", key: "geographic"},
        {text: "按赛迪分区", key: "saidiCity"},
    ];// 赛迪分区(saidiCity) / 地理分区(geographic)

    useEffect(() => { 
        getRegionsList();
    }, [])

    useEffect(()=>{
        console.log(searchData,countryDeptList,regionList,"tooltipIsOpen")
        setSelectedAreaList(searchData.codes ? searchData.codes : []);
        setSelectedRegions(regionList ? regionList : []);

        setSelectedMinistriesList(searchData.countryDeptIds ? searchData.countryDeptIds : []);
        setSelectedMinistries(countryDeptList ? countryDeptList : []);
        
    },[searchData.countryDeptIds,searchData.codes])

    const getRegionsList = async() => {
        try {
            let res = await Api.Common.getRegions({});
            if(res && res.code === 0 && res.data){
                setRegions(res.data)
            }else{}
        } catch (errInfo) {
            console.log('验证失败:', errInfo);
        }

        try {
            let res = await Api.Common.getDepartments({data: {type: 2}});
            if (res && res.code === 0 && res.data) {
                setAllRegions(res.data[0].childList || [])
            } else {
            }
        } catch (errInfo) {
            console.log('验证失败:', errInfo);
        }
    }


    // 地方弹窗-选中
    const renderRegions = (sortType, selectedCodes, selectedDepartCodesList = [], selectedMinistriesCode) => {
        const areaList = regions[sortType] || [];

        let _codes = [], countryDeptIds = [];
        selectedCodes.map(item=>{
            if(item.length > 5 || item == 156){
                _codes.push(item)
            }else{
                countryDeptIds.push(item)
            }
        })

        // 地理分区
        let allAreaCodeList = [], allAreaList = [];
        areaList.forEach(areaItem => {
            const addressChildren = areaItem.children || [];
            addressChildren.forEach(addressItem => {
                allAreaCodeList.push(addressItem.code);
                allAreaList.push(addressItem);
            })
        });

        // 地方政府
        let allLocalGovernmentCodeList = [];
        allRegions.forEach(localItem => {
            allLocalGovernmentCodeList.push(localItem.id);
        });

        const isAllSelected = selectedCodes.length >= allAreaCodeList.length;
        
        const isAllLocalGovernmentSelected = selectedMinistriesCode.length >= allLocalGovernmentCodeList.length;

        return (
            <div className="regionsPopoverBox">
                <div className="sortTypeListBox">
                    {
                        sortTypeList.map(item => {
                            const {text, key} = item;
                            const isActive = sortType === key;
                            return (
                                <span
                                    className={`sortItem ${isActive ? "activeStatus" : ""}`}
                                    key={key}
                                    onClick={() => {
                                        if (!isActive) {
                                            setSortType(key)
                                        }
                                    }}
                                >{text}</span>
                            )
                        })
                    }
                </div>
                <div className="areaListBox">
                    <div className='regionsPlace'>
                        <span
                            className={`regionsAllArea ${isAllSelected ? "selectRegion" : ""}`}
                            onClick={()=>{
                                regionsChange(isAllSelected ? [] : allAreaList, isAllSelected ? [] : allAreaCodeList)
                            }}
                        >全部地区</span>
                        <div className="regionsAllListBox">
                            {
                                areaList.map(item => {
                                    let addressIsAllSelected = true;
                                    const addressCodeList = [];
                                    for (const addressItem of item.children) {
                                        const code = addressItem.code;
                                        let flag = selectedCodes.includes(code);
                                        if (addressIsAllSelected) {
                                            addressIsAllSelected = flag;
                                        }
                                        addressCodeList.push(code);
                                    }
                                    return (
                                        <div key={item.id} className="regionsList">
                                            <span
                                                className={`regionsArea ${(addressIsAllSelected || isAllSelected) ? "selectRegion" : ""}`}
                                                onClick={()=>{
                                                    console.log(item)
                                                    let codes = [...selectedCodes], ministries = [];
                                                    if (addressIsAllSelected) {
                                                        addressCodeList.forEach(code => {
                                                            let idx = codes.indexOf(code);
                                                            codes.splice(idx, 1);
                                                        })
                                                        // 删除选中
                                                        selectedRegions.map((it,index)=>{
                                                            if(!addressCodeList.includes(it.code)){
                                                                ministries.push(it);
                                                            }
                                                        })
                                                    } else {
                                                        addressCodeList.forEach(code => {
                                                            if (!codes.includes(code)) {
                                                                codes.push(code);
                                                            }
                                                        })
                                                        // 选中大类型
                                                        let newDate = [...selectedRegions,...item.children];
                                                        ministries = newDate.filter((item, index, self) => {
                                                            return index === newDate.findIndex((obj2) => obj2.code === item.code)
                                                        });
                                                        console.log(ministries,"ministries")
                                                    }
                                                    regionsChange(ministries, codes)

                                                }}
                                            >{item.name}</span>
                                            <div className="regionsBox">
                                                {
                                                    item.children.map(it => {
                                                        const {code, name} = it;
                                                        const idx = selectedCodes.indexOf(code);
                                                        const isSelected = idx > -1;
                                                        return (
                                                            <span
                                                                key={code}
                                                                onClick={() => {
                                                                    let codes = [...selectedCodes], regions = [...selectedRegions];
                                                                    if (isSelected) {
                                                                        codes.splice(idx, 1);
                                                                        regions.splice(idx, 1);
                                                                    } else {
                                                                        codes.push(code);
                                                                        regions.push(it);
                                                                    }
                                                                    regionsChange(regions, codes);
                                                                }}
                                                                className={`regionsItem ${(isSelected || addressIsAllSelected || isAllSelected) ? "selectRegion" : ""}`}
                                                            >{name}</span>
                                                        )
                                                    })
                                                }
                                            </div>
                                        </div>
                                    )
                                })
                            }
                        </div>
                    </div>
                    
                    <div className='localGovernment'>
                        <span
                            className={`regionsAllArea ${isAllLocalGovernmentSelected ? "selectRegion" : ""}`}
                            onClick={() => {
                                ministriesChange(isAllLocalGovernmentSelected ? [] : allRegions, isAllLocalGovernmentSelected ? [] : allLocalGovernmentCodeList)
                            }}
                        >全部地方政府机构</span>
                        <div className="regionsAllListBox">
                            <div className="regionsAllList">
                                {
                                    allRegions.map(item => {
                                        let addressIsAllSelected = false;
                                        const addressCodeList = [];
                                        const {id, name} = item;
                                        const idx = selectedMinistriesCode.indexOf(id);
                                        const isSelected = idx > -1;
                                        return (
                                            <span
                                                key={item.id}
                                                onClick={() => {
                                                    let codes = [...selectedMinistriesCode], ministries = [...selectedDepartCodesList];
                                                    if (isSelected) {
                                                        codes.splice(idx, 1);
                                                        ministries.splice(idx, 1);
                                                    } else {
                                                        codes.push(item.id);
                                                        ministries.push(item);
                                                    }
                                                    ministriesChange(ministries,codes);
                                                }}
                                                className={`regionsItem ${(isSelected || addressIsAllSelected || isAllLocalGovernmentSelected) ? "selectRegion" : ""}`}
                                            >{name}</span>
                                        )
                                    })
                                }
                            </div>
                        </div>
                    </div>
                    

                </div>
                <div className="footerOperateBox">
                    <span className="operateBtn cancelBtn"
                          onClick={() => cancelChangeRegions()}>取消</span>
                    <span className="operateBtn confirmBtn"
                          onClick={() => confirmChangeRegions(selectedRegions, selectedMinistries, selectedAreaList, selectedMinistriesList)}>确定</span>
                </div>
            </div>
        )
    }

    const regionsChange = (regions, codes) => {
        setSelectedAreaList(codes);
        setSelectedRegions(regions);
    }
    const cancelChangeRegions = () => {
        setTooltipIsOpen(false);
        regionsChange(regionList,[...(searchData.codes || [])]);
        ministriesChange(countryDeptList,[...(searchData.countryDeptIds || [])]);
    }

    const confirmChangeRegions = (region, ministries, codes, selectedDepartCodesList) => {
        setTooltipIsOpen(false);
        console.log(region,"regionregionregion")
        callBack({
            "codes":[...codes] || [],
            "codesList": [...region] || [],
            "countryDeptIds": [...selectedDepartCodesList] || [],
            "countryDeptList": [...ministries] || []
        })
    }

    const ministriesChange = (data,codes) => {
        setSelectedMinistriesList(codes);
        setSelectedMinistries(data);
    }

    return(
        <>
            <Tooltip
                open={tooltipIsOpen }
                overlayClassName={"areaOrDepartmentTooltipBox"}
                placement={"bottomRight"}
                title={(
                    <div className="areaOrDepartmentContentBox" onClick={e => e.stopPropagation()}>
                        {renderRegions(sortType, selectedAreaList, selectedMinistries, selectedMinistriesList)}
                    </div>
                )}
                trigger={"click"}
                onClick={e => e?.stopPropagation()}
            >
                <div onClick={()=>setTooltipIsOpen(key)} style={{display: "inline-block"}}>
                    {ministryHtml}
                </div>
            </Tooltip>
        </>
    )
}

export default Local;
